import {createElementAnd, raf} from "./util";
import {closest} from "./dom";

export function registerSocialCorner() {
    raf(() => Array
        .from(document.querySelectorAll("div.tab-container#social-corner"))
        .forEach(el => new SocialCorner(el)));
}

export class SocialCorner {

    constructor(el) {
        this.el = {
            root: el,
            loader: Array.from(el.querySelectorAll("[data-booking-loader]")),
            tabs: Array.from(el.querySelectorAll("ul.tab-container-tabs li.nav-item"))
        };

        this.el.tabs.forEach(el => el.addEventListener("click", evt => this.onTabClicked(evt)));
    }

    loadTab(tab) {
        this.el.loader.forEach(el => el.style.setProperty("display", "block"));
        Array.from(this.el.root.querySelectorAll("[data-sc-tab]")).forEach(el => el.style.setProperty("display", "none"));

        switch (tab) {
            case "facebook":
                fetch(`https://api.ideemedia.cloud/facebook/${hcdcI18n.facebookPageId}/feed?limit=10`)
                    .then(r => r.json())
                    .then(r => this.onFacebookFeedLoaded(r))
                    .catch(err => console.error(err));
                break;

            case "youtube":
                fetch(`/api/social/youtube/channel/${hcdcI18n.youtubeChannelId}/videos.json?limit=2`)
                    .then(r => r.json())
                    .then(r => this.onYouTubeChannelVideosLoaded(r))
                    .catch(err => console.error(err));
                break;
        }
    }

    onFacebookFeedLoaded(response) {
        if (response.success !== true)
            return;

        const storiesContainer = this.el.root.querySelector(`[data-sc-tab="facebook"]`);
        storiesContainer.innerHTML = "";

        for (let story of response.data) {
            if (story === undefined || story === null)
                continue;

            const text = story.formatted.story || story.story || story.name || story.from_name;

            storiesContainer.appendChild(createElementAnd("article", article => {
                article.classList.add("sc-story");

                article.appendChild(createElementAnd("header", header => {
                    header.appendChild(createElementAnd("span", span => {
                        span.classList.add("story");
                        span.innerHTML = text;
                    }));

                    header.appendChild(createElementAnd("span", span => {
                        span.classList.add("date");
                        span.innerHTML = moment(story.created_on * 1000).format("LLL");
                    }));
                }));

                article.appendChild(createElementAnd("main", main => {
                    main.dataset.type = story.type;

                    main.appendChild(createElementAnd("div", div => {
                        div.classList.add("embed-responsive");
                        div.classList.add("embed-responsive-16by9");
                        div.style.setProperty("background-image", `url(${story.picture})`);
                    }));
                }));

                if (story.message !== undefined && story.message !== "") {
                    article.appendChild(createElementAnd("main", main => {
                        main.classList.add("sc-message");
                        main.innerHTML = story.formatted.message || story.message;
                    }));
                }

                article.appendChild(createElementAnd("footer", footer => {
                    footer.appendChild(createElementAnd("a", a => {
                        a.classList.add("btn");
                        a.classList.add("btn-primary");
                        a.classList.add("btn-sm");
                        a.setAttribute("href", story.link || story.permalink);
                        a.setAttribute("target", "_blank");
                        a.innerHTML = hcdcI18n.linkMore;
                    }));
                }));
            }));
        }

        this.onLoadingDone();
    }

    onYouTubeChannelVideosLoaded(response) {
        if (response.success !== true)
            return;

        const videosContainer = this.el.root.querySelector(`[data-sc-tab="youtube"]`);
        videosContainer.innerHTML = "";

        for (let video of response.data) {
            videosContainer.appendChild(createElementAnd("article", article => {
                article.classList.add("sc-story");

                article.appendChild(createElementAnd("header", header => {
                    header.appendChild(createElementAnd("span", span => {
                        span.classList.add("story");
                        span.innerHTML = hcdcI18n.youtubeStory;
                    }));

                    header.appendChild(createElementAnd("span", span => {
                        span.classList.add("date");
                        span.innerHTML = moment(video.published * 1000).format("LLL");
                    }));
                }));

                article.appendChild(createElementAnd("main", main => {
                    main.dataset.statusType = "youtube_video";
                    main.dataset.type = "youtube";
                    main.innerHTML = video.embed;
                }));
            }));
        }

        this.onLoadingDone();
    }

    onLoadingDone() {
        this.el.loader.forEach(el => el.style.setProperty("display", "none"));
        Array.from(this.el.root.querySelectorAll("[data-sc-tab]")).forEach(el => el.style.setProperty("display", "block"));
    }

    onTabClicked(evt) {
        let tab = evt.target;

        if (tab.classList.contains("nav-item"))
            tab = tab.children[0];

        if (!tab.classList.contains("nav-link"))
            tab = closest(tab, "[data-target]");

        if (!tab || !tab.dataset.target)
            return;

        this.loadTab(tab.dataset.target.substr(8));
    }

}
